export default "__VITE_ASSET__1d2da05d__"